import useThemeHook from "../hooks/useThemeHook";
import { THEME_COLORS } from "../themes/DarkLight";
import CommonButton from "./CommonButton";
function CallToActionCard({
  title,
  description,
  buttonText,
  onClick,
  buttonBg,
}: {
  title: string;
  description: string;
  buttonText: string;
  onClick: Function;
  buttonBg?: string;
}) {
  const theme = useThemeHook();

  return (
    <div style={{ padding: "10px" }}>
      <div
        style={{
          backgroundColor: THEME_COLORS[theme].less_theme,
          borderRadius: "10px",
          padding: "5px",
          display: "flex",
          flexDirection: "column",
          gap: "10px",
        }}
      >
        <h3
          style={{
            fontWeight: "500",
            color: THEME_COLORS[theme].inverse_theme,
          }}
        >
          {title}
        </h3>
        <p
          style={{ fontSize: "15px", color: THEME_COLORS[theme].inverse_theme }}
        >
          {description}
        </p>
        <div>
          <CommonButton
            backgroundColor={buttonBg}
            onClickHandle={onClick}
            text={buttonText}
          />
        </div>
      </div>
    </div>
  );
}

export default CallToActionCard;
